export default __webpack_public_path__ + "static/media/342.b5eacb8a.gif";